import createSelector from 'web-app/util/custom-create-selector';
import * as Constants from 'web-app/react/inbox/constants';

export const inboxType = state => state.inbox.conversationCenter.type || Constants.InboxTypes.OWN;
export const conversations = state => state.inbox.conversationCenter.conversations;
export const conversationsCounts = state => state.notifications.notificationCounts.conversations;
export const fetching = state => state.inbox.conversationCenter.fetching;
export const archived = state => state.inbox.conversationCenter.archived;
export const offset = state => state.inbox.conversationCenter.offset;
export const canFetchMoreInbox = state => state.inbox.conversationCenter.canFetchMoreInbox;

export const canLoadMore = createSelector(
    inboxType,
    conversations,
    conversationsCounts,
    (inboxType, conversations, conversationsCounts) => conversations.size < conversationsCounts[inboxType].total,
);

export const conversationIds = createSelector(conversations, allConversations =>
    allConversations.map(({conversationId}) => conversationId).filter(_ => _),
);
